<template>
  <section class="section social-section reveal-section" id="redes" ref="sectionRef">
    <div class="section-header">
      <span class="section-label" style="color:var(--vh-dorado)">Conecta</span>
      <h2 class="section-title" style="color:white">Síguenos en Redes</h2>
      <p class="section-subtitle" style="color:rgba(255,255,255,0.8)">Mantente al día con nuestra comunidad</p>
    </div>
    <div class="social-grid">
      <div class="social-card" v-for="(network, i) in networks" :key="i">
        <div class="social-header" :style="{ background: network.gradient }">
          <i :class="network.icon"></i>
        </div>
        <div class="social-content">
          <h3>{{ network.name }}</h3>
          <p>{{ network.description }}</p>
          <a :href="network.url" target="_blank" rel="noopener noreferrer" class="visit-btn">Visitar {{ network.name }}</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useScrollReveal } from '@/composables/useAnimations';

const sectionRef = ref(null);
const { registerReveal } = useScrollReveal();
onMounted(() => registerReveal(sectionRef.value));
const networks = [
  { name: 'TikTok', description: 'Contenido dinámico y viral. Sigue nuestros videos cortos, tendencias y mensajes inspiradores.', icon: 'fab fa-tiktok', gradient: 'linear-gradient(135deg, #000000, #1a1a1a)', url: 'https://www.tiktok.com' },
  { name: 'WhatsApp', description: 'Chatea con nosotros directamente. Respondemos rápido a tus consultas.', icon: 'fab fa-whatsapp', gradient: 'linear-gradient(135deg, #25D366, #128C7E)', url: 'https://wa.me/50241498852' },
  { name: 'Instagram', description: 'Momentos especiales, historias de fe y actualizaciones diarias de nuestros programas.', icon: 'fab fa-instagram', gradient: 'linear-gradient(135deg, #feda75, #fa7e1e, #d92e7f, #9b36b7, #515bd4)', url: 'https://www.instagram.com/vision_house_gt/' },
  { name: 'Facebook', description: 'Comunidad activa, eventos, transmisiones en vivo y conexión profunda con nuestro ministerio.', icon: 'fab fa-facebook-f', gradient: 'linear-gradient(135deg, #0a66c2, #0052cc)', url: 'https://www.facebook.com/profile.php?id=61574895160076' },
  { name: 'YouTube', description: 'Predicaciones completas, conferencias, testimonios y contenido educativo de valor.', icon: 'fab fa-youtube', gradient: 'linear-gradient(135deg, #ff0000, #ff6600)', url: 'https://www.youtube.com' },
];
</script>

<style scoped>
.social-section {
  background: linear-gradient(135deg, var(--vh-azul-profundo), var(--vh-azul-oscuro));
  position: relative;
  overflow: hidden;
  padding: 7rem 5%;
}
.social-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 50%, rgba(93,173,226,0.15) 0%, transparent 50%),
              radial-gradient(circle at 80% 80%, rgba(251,166,54,0.1) 0%, transparent 50%);
}
.section-header { text-align: center; margin-bottom: 5rem; position: relative; z-index: 1; }
.section-label {
  display: inline-block;
  font-weight: 700; font-size: 0.8rem;
  text-transform: uppercase; letter-spacing: 3px;
  margin-bottom: 1rem; font-family: 'Barlow', sans-serif;
}
.section-title {
  font-size: clamp(2.2rem, 4vw, 3.2rem);
  margin-bottom: 1.2rem; line-height: 1.1;
}
.section-subtitle {
  max-width: 650px;
  margin: 0 auto; font-size: 1.15rem; line-height: 1.8;
}
.social-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}
.social-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 5px 25px var(--vh-sombra);
  transition: var(--vh-transicion);
  border-top: 5px solid var(--vh-dorado);
  position: relative;
}
.social-card:hover {
  transform: translateY(-12px) scale(1.01);
  box-shadow: 0 15px 50px var(--vh-sombra);
}
.social-header {
  width: 100%;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.social-header::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(26,75,140,0.7), rgba(251,166,54,0.5));
}
.social-header i {
  font-size: 4rem;
  position: relative;
  z-index: 2;
  color: white;
  transition: transform 0.3s;
}
.social-card:hover .social-header i {
  transform: scale(1.2) rotate(-5deg);
}
.social-content { padding: 2rem; }
.social-content h3 {
  font-size: 1.5rem;
  color: var(--vh-azul-profundo);
  margin-bottom: 0.8rem;
}
.social-content p {
  color: #555;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
}
.visit-btn {
  display: inline-block;
  padding: 0.8rem 2rem;
  background: var(--vh-dorado);
  color: white;
  font-family: 'Barlow', sans-serif;
  font-weight: 600;
  border-radius: 50px;
  text-decoration: none;
  transition: var(--vh-transicion);
  border: none;
  cursor: pointer;
  font-size: 0.95rem;
}
.visit-btn:hover {
  background: var(--vh-dorado-hover);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(251, 166, 54, 0.3);
}
</style>
